/*
 * Welle 3b – Wissensbereich (Präfix kn-). Eine Datei für Wissens-, Artikel-, FAQ- und Glossar-Seite.
 * Datenquellen: die Blöcke der FAQ-Seite, der Glossar-Seite und der Artikel-Übersicht. Jede dieser
 * Seiten gibt ihre Daten als <script type="application/json" data-kn-data="…"> aus; andere Seiten
 * laden sie per fetch nach (eine Quelle, keine Doppelpflege).
 */
(function () {
  "use strict";
  if (window.__knInit) return;
  window.__knInit = true;

  var cfg = { urls: {}, cats: {}, t: {} };
  var cache = {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function escRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function catName(k) { return (cfg.cats && cfg.cats[k]) || ""; }
  function hashUrl(base, id) { return (base || "") + "#" + id; }
  function samePath(a, b) {
    try {
      return new URL(a, location.href).pathname.replace(/\/$/, "") === new URL(b, location.href).pathname.replace(/\/$/, "");
    } catch (e) { return false; }
  }

  function readLocal(kind) {
    var el = document.querySelector('script[data-kn-data="' + kind + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function load(kind) {
    if (cache[kind]) return cache[kind];
    var local = readLocal(kind);
    if (local) { cache[kind] = Promise.resolve(local); return cache[kind]; }
    var url = kind === "faq" ? cfg.urls.faq : kind === "glossary" ? cfg.urls.glossary : cfg.urls.blog;
    if (!url || !window.fetch) { cache[kind] = Promise.resolve(null); return cache[kind]; }
    cache[kind] = fetch(url, { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("status " + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var el = doc.querySelector('script[data-kn-data="' + kind + '"]');
        return el ? JSON.parse(el.textContent) : null;
      })
      .catch(function () { return null; });
    return cache[kind];
  }

  /* ---------- Glossar-Tooltips ---------- */
  var tipSeq = 0;
  function wrapFirst(root, term, g) {
    var re;
    try {
      re = new RegExp("(^|[^\\p{L}\\p{N}])(" + escRe(term) + "(?:e?s)?)(?![\\p{L}\\p{N}])", "iu");
    } catch (e) {
      re = new RegExp("(^|[^A-Za-z0-9])(" + escRe(term) + "(?:e?s)?)(?![A-Za-z0-9])", "i");
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest("a, .kn-gt, summary")) continue;
      var m = re.exec(node.nodeValue);
      if (!m) continue;
      var start = m.index + m[1].length;
      var mid = node.splitText(start);
      mid.splitText(m[2].length);
      var a = document.createElement("a");
      a.className = "kn-gt";
      a.href = hashUrl(cfg.urls.glossary, g.id);
      var tipId = "kn-tip-" + (++tipSeq);
      a.setAttribute("aria-describedby", tipId);
      a.textContent = mid.nodeValue;
      var tip = document.createElement("span");
      tip.className = "kn-gtp";
      tip.id = tipId;
      tip.setAttribute("role", "tooltip");
      tip.innerHTML = "<b>" + esc(g.t) + "</b>" + esc(g.d);
      a.appendChild(tip);
      mid.parentNode.replaceChild(a, mid);
      return true;
    }
    return false;
  }
  function applyTerms(scope) {
    var targets = $$("[data-kn-terms]", scope).filter(function (el) { return (el.getAttribute("data-kn-terms") || "").trim(); });
    if (!targets.length) return;
    load("glossary").then(function (data) {
      if (!data || !data.items) return;
      var map = {};
      data.items.forEach(function (g) { map[String(g.t).toLowerCase()] = g; });
      targets.forEach(function (el) {
        if (el.getAttribute("data-kn-done")) return;
        el.setAttribute("data-kn-done", "1");
        el.getAttribute("data-kn-terms").split(",").forEach(function (raw) {
          var term = raw.trim();
          var g = map[term.toLowerCase()];
          if (g) wrapFirst(el, term, g);
        });
      });
    });
  }
  function initTouchTips() {
    document.addEventListener("click", function (e) {
      var g = e.target.closest && e.target.closest(".kn-gt");
      if (!g || window.matchMedia("(hover: hover)").matches) return;
      if (g.getAttribute("data-armed") !== "1") {
        e.preventDefault();
        $$('.kn-gt[data-armed="1"]').forEach(function (x) { x.removeAttribute("data-armed"); x.blur(); });
        g.setAttribute("data-armed", "1");
        g.focus();
      }
    });
    document.addEventListener("focusout", function (e) {
      var g = e.target.closest && e.target.closest(".kn-gt");
      if (g) setTimeout(function () { if (document.activeElement !== g) g.removeAttribute("data-armed"); }, 50);
    });
  }

  /* ---------- Taste „/" ---------- */
  function initSlash(input) {
    if (!input) return;
    document.addEventListener("keydown", function (e) {
      var t = document.activeElement && document.activeElement.tagName;
      if (e.key === "/" && t !== "INPUT" && t !== "TEXTAREA" && !(document.activeElement && document.activeElement.isContentEditable)) {
        e.preventDefault();
        input.focus();
        input.scrollIntoView({ block: "center", behavior: reduceMotion ? "auto" : "smooth" });
      }
    });
  }
  function initSearchLinks() {
    $$("[data-kn-searchlink-inline]").forEach(function (a) { a.href = (cfg.urls.knowledge || "") + "#kn-search"; });
  }

  /* ---------- Filter (FAQ, Glossar) ---------- */
  function initFilter(kind) {
    var input = document.querySelector('[data-kn-filter="' + kind + '"]');
    if (!input) return;
    var root = document.querySelector('[data-kn-page="' + kind + '"]');
    var items = $$("[data-kn-item]", root);
    var groups = $$("[data-kn-group]", root);
    var none = root.querySelector("[data-kn-none]");
    input.addEventListener("input", function () {
      var v = input.value.trim().toLowerCase();
      var n = 0;
      items.forEach(function (it) {
        var hay = it.getAttribute("data-s");
        if (!hay) {
          var c = it.cloneNode(true);
          $$(".kn-gtp", c).forEach(function (x) { x.parentNode.removeChild(x); });
          hay = c.textContent;
        }
        hay = hay.toLowerCase();
        var ok = !v || hay.indexOf(v) !== -1;
        it.hidden = !ok;
        if (ok) { n++; if (v && it.tagName === "DETAILS") it.open = true; }
      });
      groups.forEach(function (g) {
        g.hidden = !$$("[data-kn-item]", g).some(function (i) { return !i.hidden; });
        var link = root.querySelector('[data-kn-spy-link="' + g.id + '"]');
        if (link) link.hidden = g.hidden;
        var letter = root.querySelector('[data-kn-letter="' + g.id.replace("l-", "") + '"]');
        if (letter) letter.style.opacity = g.hidden ? ".35" : "";
      });
      if (none) none.classList.toggle("is-on", n === 0);
    });
    initSlash(input);
  }

  /* ---------- Scroll-Spy ---------- */
  function initSpy(links, targets, offset) {
    if (!links.length || !targets.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var k = -1;
      targets.forEach(function (t, i) { if (!t.hidden && t.getBoundingClientRect().top < offset) k = i; });
      links.forEach(function (a, i) { a.classList.toggle("is-on", i === k); });
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- FAQ-Seite ---------- */
  function initFaqPage() {
    var root = document.querySelector('[data-kn-page="faq"]');
    if (!root) return;
    initFilter("faq");
    var nav = root.querySelector("[data-kn-spy]");
    if (nav) {
      var links = $$("[data-kn-spy-link]", nav);
      var targets = links.map(function (a) { return document.getElementById(a.getAttribute("data-kn-spy-link")); }).filter(Boolean);
      initSpy(links, targets, 220);
    }
    applyTerms(root);
    if (location.hash && location.hash.indexOf("#q-") === 0) {
      var d = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (d && d.tagName === "DETAILS") { d.open = true; setTimeout(function () { d.scrollIntoView({ block: "start" }); }, 60); }
    }
  }

  /* ---------- Glossar-Seite ---------- */
  function initGlossaryPage() {
    var root = document.querySelector('[data-kn-page="glossary"]');
    if (!root) return;
    initFilter("glossary");
    var letters = $$("[data-kn-letter]", root);
    var groups = letters.map(function (a) { return document.getElementById("l-" + a.getAttribute("data-kn-letter")); }).filter(Boolean);
    initSpy(letters, groups, 260);
    $$("[data-kn-copy]", root).forEach(function (b) {
      var label = b.textContent;
      b.addEventListener("click", function () {
        var url = location.origin + location.pathname + location.search + "#" + b.getAttribute("data-kn-copy");
        var done = function () { b.textContent = cfg.t.copied || label; setTimeout(function () { b.textContent = label; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
        else done();
      });
    });
    if (location.hash) {
      var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (el && el.classList.contains("kn-gle")) { el.classList.add("is-flash"); setTimeout(function () { el.classList.remove("is-flash"); }, 2400); }
    }
  }

  /* ---------- Artikel-Übersicht ---------- */
  function initBlog() {
    var root = document.querySelector('[data-kn-page="blog"]');
    if (!root) return;
    var chips = $$("[data-kn-chips] .kn-chip", root);
    var cards = $$("[data-kn-cards] .kn-card", root);
    var bqs = $$(".kn-bq", root);
    var empty = root.querySelector("[data-kn-bempty]");
    function set(c, push) {
      if (!chips.some(function (b) { return b.getAttribute("data-c") === c; })) c = "all";
      chips.forEach(function (b) { b.setAttribute("aria-selected", b.getAttribute("data-c") === c ? "true" : "false"); });
      var n = 0;
      cards.forEach(function (card) { var ok = c === "all" || card.getAttribute("data-c") === c; card.hidden = !ok; if (ok) n++; });
      bqs.forEach(function (q) { q.classList.toggle("is-on", q.getAttribute("data-c") === c); });
      if (empty) empty.classList.toggle("is-on", n === 0);
      if (push && window.history && history.replaceState) {
        var u = new URL(location.href);
        if (c === "all") u.searchParams.delete("c"); else u.searchParams.set("c", c);
        history.replaceState(null, "", u.toString());
      }
    }
    chips.forEach(function (b) { b.addEventListener("click", function () { set(b.getAttribute("data-c"), true); }); });
    var start = new URLSearchParams(location.search).get("c");
    set(start || "all", false);
  }

  /* ---------- Artikel ---------- */
  function initArticle() {
    var root = document.querySelector('[data-kn-page="article"]');
    if (!root) return;
    var prose = root.querySelector("[data-kn-prose]");
    var toc = root.querySelector("[data-kn-toc]");
    if (prose && toc) {
      var hs = $$("h2", prose).filter(function (h) { return h.textContent.trim(); });
      if (hs.length >= 2) {
        var nav = toc.querySelector("nav");
        hs.forEach(function (h, i) {
          if (!h.id) h.id = "kn-h-" + (i + 1);
          var a = document.createElement("a");
          a.href = "#" + h.id;
          a.innerHTML = "<i>" + (i < 9 ? "0" : "") + (i + 1) + "</i><span>" + esc(h.textContent.trim()) + "</span>";
          nav.appendChild(a);
        });
        toc.hidden = false;
        initSpy($$("a", nav), hs, 160);
        // O-112 (A68): bis 800 px zugeklappt, Knopf zeigt die Anzahl der Abschnitte.
        var tb = toc.querySelector("[data-kn-toc-btn]");
        var tn = toc.querySelector("[data-kn-toc-n]");
        if (tn) tn.textContent = "(" + hs.length + ")";
        if (tb) {
          var setOpen = function (open) { toc.classList.toggle("is-collapsed", !open); tb.setAttribute("aria-expanded", open ? "true" : "false"); };
          if (window.matchMedia && window.matchMedia("(max-width: 800px)").matches) setOpen(false);
          tb.addEventListener("click", function () { setOpen(toc.classList.contains("is-collapsed")); });
          nav.addEventListener("click", function (e) { if (e.target.closest("a") && window.matchMedia && window.matchMedia("(max-width: 800px)").matches) setOpen(false); });
        }
      }
    }
    // O-112 (A68): erstes Bild im Artikeltext ausblenden, wenn es dasselbe Foto wie das Titelbild ist
    // und vor dem ersten Text steht (Altinhalte aus der Blog-App wiederholen das Titelbild).
    var heroImg = root.querySelector(".kn-ahero__img img");
    var firstImg = prose ? prose.querySelector("img") : null;
    if (heroImg && firstImg) {
      var key = function (u) { return String(u || "").split("?")[0].split("/").pop().replace(/\.[a-z0-9]+$/i, "").replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)$/i, "").toLowerCase(); };
      var fSrc = firstImg.getAttribute("data-src") || firstImg.currentSrc || firstImg.src;
      var r = document.createRange();
      r.setStart(prose, 0);
      r.setEndBefore(firstImg);
      if (key(fSrc) && key(fSrc) === key(heroImg.currentSrc || heroImg.src) && !r.toString().trim()) {
        var box = firstImg.closest(".bggle_image, figure, p") || firstImg;
        if (prose.contains(box)) box.style.display = "none";
      }
    }
    var copy = root.querySelector("[data-kn-copy-url]");
    var ok = root.querySelector("[data-kn-copy-ok]");
    if (copy) copy.addEventListener("click", function () {
      var done = function () { if (ok) { ok.textContent = cfg.t.copied || ""; setTimeout(function () { ok.textContent = ""; }, 2000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(location.href.split("#")[0]).then(done, done);
      else done();
    });
    // Analytics (Buendel E, 30.09.2026): knowledge_read once per page view, as soon as 75 % of the
    // article text has passed the bottom edge of the window. Only the public article handle is sent.
    var aid = root.getAttribute("data-kn-article");
    if (prose && aid && window.cryonosTrack) {
      var sent = false;
      var onScroll = function () {
        if (sent) return;
        var r = prose.getBoundingClientRect();
        if (r.height > 0 && (window.innerHeight - r.top) / r.height >= 0.75) {
          sent = true;
          window.removeEventListener("scroll", onScroll);
          window.cryonosTrack("knowledge_read", { article_id: aid });
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Wissens-Seite ---------- */
  function initHub() {
    var hasHub = document.querySelector("[data-kn-search], [data-kn-count], [data-kn-catcount], [data-kn-artcat], [data-kn-faq-preview], [data-kn-gl-preview]");
    if (!hasHub) return;
    var onlyArt = !document.querySelector("[data-kn-search], [data-kn-count], [data-kn-catcount], [data-kn-faq-preview], [data-kn-gl-preview]");
    var none = Promise.resolve(null);
    Promise.all([load("blog"), onlyArt ? none : load("faq"), onlyArt ? none : load("glossary")]).then(function (res) {
      var blog = res[0] || { items: [] }, faq = res[1] || { items: [] }, gl = res[2] || { items: [] };
      var bi = blog.items || [], fi = faq.items || [], gi = gl.items || [];

      $$('[data-kn-count="faq"]').forEach(function (e) { e.textContent = fi.length; });
      $$('[data-kn-count="gl"]').forEach(function (e) { e.textContent = gi.length; });

      var tpl = document.querySelector('template[data-kn-tpl="catcount"]');
      $$("[data-kn-catcount]").forEach(function (box) {
        var k = box.getAttribute("data-kn-catcount");
        var n = {
          art: bi.filter(function (x) { return x.c === k; }).length,
          faq: fi.filter(function (x) { return x.c === k; }).length,
          gl: gi.filter(function (x) { return x.c === k; }).length
        };
        if (!tpl) return;
        box.innerHTML = "";
        box.appendChild(tpl.content.cloneNode(true));
        $$("[data-n]", box).forEach(function (sp) {
          var v = n[sp.getAttribute("data-n")];
          var one = v === 1;
          var form = sp.getAttribute(one ? "data-one" : "data-other") || "";
          var i = form.indexOf(one ? "1" : "2");
          sp.innerHTML = i < 0 ? esc(v + " " + form) : esc(form.slice(0, i)) + "<em>" + v + "</em>" + esc(form.slice(i + 1));
        });
      });

      $$("[data-kn-artcat]").forEach(function (el) {
        var u = el.getAttribute("data-kn-artcat");
        var hit = bi.filter(function (x) { return samePath(x.u, u); })[0];
        if (hit) el.textContent = catName(hit.c);
      });

      var fp = document.querySelector("[data-kn-faq-preview]");
      if (fp) {
        var hub = fi.filter(function (x) { return x.hub; });
        fp.innerHTML = hub.map(function (x, i) {
          return '<details class="kn-fq"' + (i === 0 ? " open" : "") + "><summary>" + esc(x.q) + '</summary><div class="kn-fq__a" data-kn-terms="' + esc(x.terms || "") + '">' + (x.h || "") +
            '</div></details>';
        }).join("");
        applyTerms(fp);
      }
      $$("[data-kn-faqall]").forEach(function (e) { var t = e.getAttribute("data-tpl"); if (t && fi.length) e.textContent = t.replace("§", fi.length); });
      $$("[data-kn-glheading]").forEach(function (e) { var t = e.getAttribute("data-tpl"); if (t && gi.length) e.textContent = t.replace("§", gi.length); });

      var az = document.querySelector("[data-kn-az]");
      if (az) {
        var have = {};
        gi.forEach(function (g) { have[String(g.t).trim().charAt(0).toUpperCase()] = true; });
        $$("[data-l]", az).forEach(function (s) {
          var l = s.getAttribute("data-l");
          if (!have[l]) return;
          var a = document.createElement("a");
          a.href = hashUrl(cfg.urls.glossary, "l-" + l);
          a.textContent = l;
          s.parentNode.replaceChild(a, s);
        });
      }
      var gp = document.querySelector("[data-kn-gl-preview]");
      if (gp) {
        gp.innerHTML = gi.filter(function (g) { return g.hub; }).map(function (g) {
          var d = String(g.d || "");
          if (d.length > 90) d = d.slice(0, 88).replace(/\s+\S*$/, "") + " …";
          return '<a class="kn-gtz" href="' + esc(hashUrl(cfg.urls.glossary, g.id)) + '"><b>' + esc(g.t) + "</b><s>" + esc(d) + "</s></a>";
        }).join("");
      }

      initSearch(bi, fi, gi);
    });
  }

  function initSearch(bi, fi, gi) {
    var box = document.querySelector("[data-kn-search]");
    if (!box) return;
    var q = box.querySelector("[data-kn-q]");
    var res = box.querySelector("[data-kn-res]");
    var scope = "all", sel = -1;
    var idx = []
      .concat(bi.map(function (x) { return { k: "art", t: x.t, d: x.e || "", c: catName(x.c), u: x.u }; }))
      .concat(fi.map(function (x) { return { k: "faq", t: x.q, d: x.a || "", c: catName(x.c), u: hashUrl(cfg.urls.faq, x.id) }; }))
      .concat(gi.map(function (x) { return { k: "gl", t: x.t, d: x.d || "", c: catName(x.c), u: hashUrl(cfg.urls.glossary, x.id) }; }));
    var lbl = { art: cfg.t.articles || "Articles", faq: cfg.t.faq || "FAQ", gl: cfg.t.glossary || "Glossary" };
    function run() {
      var v = q.value.trim().toLowerCase();
      if (!v) { res.classList.remove("is-on"); res.innerHTML = ""; return; }
      var words = v.split(/\s+/).filter(Boolean);
      var re = new RegExp("(" + words.map(escRe).join("|") + ")", "gi");
      var hi = function (s) { return esc(s).replace(re, "<mark>$1</mark>"); };
      var hits = idx.filter(function (x) {
        if (scope !== "all" && x.k !== scope) return false;
        var hay = (x.t + " " + x.d + " " + x.c).toLowerCase();
        return words.every(function (w) { return hay.indexOf(w) !== -1; });
      }).map(function (x) {
        var tl = x.t.toLowerCase();
        return { x: x, s: (tl.indexOf(v) !== -1 ? 3 : 0) + (tl.indexOf(v) === 0 ? 2 : 0) + (x.k === "gl" && tl === v ? 5 : 0) };
      }).sort(function (a, b) { return b.s - a.s; });
      if (!hits.length) {
        var contact = box.getAttribute("data-contact");
        res.innerHTML = '<div class="kn-res__none">' + esc((cfg.t.noMatch || "").replace("%q%", q.value.trim())) +
          (contact ? ' <a href="' + esc(contact) + '">' + esc(cfg.t.askTeam || "") + "</a>" : "") + "</div>";
        res.classList.add("is-on");
        return;
      }
      var g = { art: [], faq: [], gl: [] };
      hits.forEach(function (h) { g[h.x.k].push(h.x); });
      res.innerHTML = ["gl", "faq", "art"].filter(function (k) { return g[k].length; }).map(function (k) {
        return '<div class="kn-res__g"><span>' + esc(lbl[k]) + " <i>" + g[k].length + "</i></span>" + g[k].slice(0, 5).map(function (h) {
          var d = h.d.length > 120 ? h.d.slice(0, 120) + "…" : h.d;
          return '<a class="kn-res__i" href="' + esc(h.u) + '"><b>' + hi(h.t) + "</b><s>" + hi(d) + "</s><em>" + esc(h.c) + "</em></a>";
        }).join("") + "</div>";
      }).join("");
      res.classList.add("is-on");
      sel = -1;
    }
    q.addEventListener("input", run);
    q.addEventListener("keydown", function (e) {
      var it = $$(".kn-res__i", res);
      if (e.key === "Escape") { q.value = ""; run(); return; }
      if (!it.length) return;
      if (e.key === "ArrowDown") { e.preventDefault(); sel = Math.min(it.length - 1, sel + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); sel = Math.max(0, sel - 1); }
      else if (e.key === "Enter" && sel >= 0) { e.preventDefault(); location.href = it[sel].href; return; }
      else return;
      it.forEach(function (x, i) { x.classList.toggle("is-sel", i === sel); });
      if (it[sel]) it[sel].scrollIntoView({ block: "nearest" });
    });
    $$(".kn-scope button", box).forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".kn-scope button", box).forEach(function (x) { x.setAttribute("aria-selected", x === b ? "true" : "false"); });
        scope = b.getAttribute("data-k");
        run();
        q.focus();
      });
    });
    $$("[data-q]", box).forEach(function (b) {
      b.addEventListener("click", function () { q.value = b.getAttribute("data-q"); run(); q.focus(); });
    });
    initSlash(q);
    if (location.hash === "#kn-search") setTimeout(function () { q.focus(); }, 300);
    $$("[data-kn-searchlink]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (!samePath(a.href, location.href)) return;
        e.preventDefault();
        q.focus();
        box.scrollIntoView({ block: "center", behavior: reduceMotion ? "auto" : "smooth" });
      });
    });
  }

  ready(function () {
    var el = document.querySelector("script[data-kn-config]");
    if (el) { try { cfg = JSON.parse(el.textContent); } catch (e) { /* Standardwerte */ } }
    var ta = document.createElement("textarea");
    var dec = function (s) { ta.innerHTML = s; return ta.value; };
    ["cats", "t"].forEach(function (g) { Object.keys(cfg[g] || {}).forEach(function (k) { cfg[g][k] = dec(cfg[g][k]); }); });
    initSearchLinks();
    initTouchTips();
    initFaqPage();
    initGlossaryPage();
    initBlog();
    initArticle();
    initHub();
  });
})();
